import { InjectionToken } from '@angular/core';
import { LocalizationStrategy } from '@app/core/i18n/localization';

export const LOCALIZATION_STRATEGY = new InjectionToken<LocalizationStrategy>('LocalizationStrategy');
export const I18N_HOSTNAMES = new InjectionToken<{ [locale: string]: string }>('i18nHostnames');
